import { Factory } from "@/data/dao/Factory";
import { SystemDao } from "@/data/dao/service/SystemDao";
import type { ITranslation } from "@/data/model/System";

import { i18n } from "@/portal/Trans";
import { DataTable, type IDataTableConfig } from "@/portal/elements/DataTable";
import { TableFilter } from "@/portal/elements/TableFilter";
import { TranslationWindow } from "@/portal/modal/TranslationWindow";

export class TranslationEditor {
    private $element: JQuery;
    private dao?: SystemDao;
    private locationId?: string;

    private dataTable?: DataTable<ITranslation>;
    private search?: TableFilter;

    constructor(element: JQuery) {
        this.$element = element;
    }

    public loadForLocation(locationid: string): TranslationEditor {
        if (this.dao === undefined || this.dataTable === undefined) {
            this.dao = Factory.getInstance<SystemDao>(SystemDao);

            this.locationId = locationid;

            const tableConfig: IDataTableConfig<ITranslation> = {
                columnMapping: [
                    {
                        name: i18n("location.translation.key"),
                        property: "key",
                        styles: { width: "20%" },
                    },
                    {
                        name: i18n("enums.Language.German"),
                        property: "valueDe",
                        styles: { width: "18%" },
                    },
                    {
                        name: i18n("enums.Language.English"),
                        property: "valueEn",
                        styles: { width: "18%" },
                    },
                    {
                        name: i18n("enums.Language.French"),
                        property: "valueFr",
                        styles: { width: "18%" },
                    },
                    {
                        name: i18n("enums.Language.Italian"),
                        property: "valueIt",
                        styles: { width: "18%" },
                    },
                    {
                        name: "",
                        property: "id",
                        styles: { width: "110px", "text-align": "right" },
                        formatter: () => {
                            return $(
                                '<span><a class="btn btn-sm btn-clean btn-icon btn-icon-md"><i class="la la-edit"></i></a></span>'
                            );
                        },
                    },
                ],
                autoload: false,
                useJsHistory: false,
                filterProvider: {
                    getFilter: () => this.search!.getValue(),
                    setFilter: (d) => this.search!.setValue(d),
                },
            };
            this.search = new TableFilter().appendTo(this.$element.find("> .kt-portlet__body.tablefilter"));

            this.dataTable = new DataTable<ITranslation>(
                this.$element.find("> .kt-portlet__body > .kt-datatable"),
                this.dao.getTranslationDataSource(this.locationId),
                tableConfig
            );
            this.dataTable.onClick((m) => {
                this.onEditRecord(m);
            });

            this.search.addAction(
                i18n("location.translation.newEntry"),
                () => {
                    this.onEditRecord();
                },
                "la la-plus"
            );

            this.dataTable.listenTo(this.search);
            this.dataTable.loadData();
        }

        return this;
    }

    private onEditRecord(model?: ITranslation) {
        const modal = new TranslationWindow(this.locationId!, model);
        modal.onSaved = () => this.dataTable!.loadData();
        modal.onRemoved = () => this.dataTable!.loadData();

        modal.show();
    }
}
